export function apiErrorMessage(error: unknown, fallback = 'عملیات ناموفق بود'): string {
  if (error && typeof error === 'object' && 'data' in error) {
    const message = (error as { data?: { statusMessage?: string } }).data?.statusMessage
    if (message) return message
  }
  if (error instanceof Error && error.message) return error.message
  return fallback
}
